import { throwError as observableThrowError } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class HttpAuthorizationInterceptor implements HttpInterceptor {
  private readonly _storage: Storage = sessionStorage;

  constructor(private _service: AuthenticationService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers: HttpHeaders = req.headers;

    if (!headers.get('Content-Type') && !(req.body instanceof FormData)) headers = headers.append('Content-Type', 'application/json');

    const raw: string = this._storage.getItem(location.origin);
    if (raw) {
      const data: { token: string, passwordDefined: boolean } = JSON.parse(raw);

      const token: string = data.token;
      if (!!token) headers = headers.append('Authorization', 'Bearer ' + token);
    }

    // Clone the request to add the new header.
    const authReq = req.clone({ headers: headers });

    //send the newly created request
    return next.handle(authReq).pipe(
      catchError((error, caught) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            this._service.logout();
          }
        }

        //return the error to the method that called it
        return observableThrowError(error);
      })) as any;
  }
}
